import { Component, OnInit } from '@angular/core';
import { RoleManagementService } from './services/role-management.service';

@Component({
  selector: 'app-admin',
  standalone: false,
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.css'
})
export class AdminComponent implements OnInit {

  constructor(private permissionService: RoleManagementService) { }

  ngOnInit(): void {
    this.permissionService.getPermissions().subscribe((response) => {
      this.permissionService.setPermissions(response);
    });
  }


}
